import Equipe from './Equipe.js'
export default Equipe;
